import CoreBase from '../../../../services/engines/CoreBase';

class TemplateParser extends CoreBase {
    _name = 'TemplateParser';

    /**
     * Parses a raw template note body to a validated v2 templateJson object.
     * @param {object} note - raw template note from TemplateLoader
     * @returns {object|null} parsed templateJson or null
     */
    parse(note) {
        if (!note?.body) return null;

        try {
            const templateJson = JSON.parse(note.body);

            if (!templateJson.version || templateJson.version < 2) {
                this.logError(`parse: not a v2 template — version=${templateJson.version}`);
                return null;
            }

            return templateJson;
        } catch (e) {
            this.logError(`parse: body is not valid JSON — ${e.message}`);
            return null;
        }
    }
}

const templateParser = new TemplateParser();
export default templateParser;
